<template>
  <div class="app-forgot-password-sms-code">
    <div class="headline">
      <h4>
        <slot name="headline"></slot>
      </h4>
    </div>
    <div class="subline">
      <slot name="subline"></slot>
    </div>
    <b-form
      inline
      :id="'form' + _uid"
      :novalidate="true"
      @submit.prevent.stop="next"
    >
      <label class="col-form-label label-before" :for="'sms-code-' + _uid">
        <dyn-slot :slot-data="slotData">
          <slot name="lblBefore"></slot>
        </dyn-slot>
      </label>
      <b-form-group :id="'sms-code-' + _uid" :class="vflowGetFeedbackClasses('code')"
                    class="form-group-sms-code mandatory">
        <label class="col-form-label label-sms-code" :for="'sms-code-' + _uid">
          <slot name="label"></slot>
        </label>
        <b-form-input
          @blur="vflowInputBlurred('code');"
          @focus="vflowInputFocused('code');"
          type="text"
          required
          inputmode="numeric"
          autocomplete="one-time-code"
          ref="code"
          name="code"
          v-model="code"
          @input="$v.code.$touch"
        ></b-form-input>
        <b-form-invalid-feedback v-if="!$v.code.tokenValidation">
          <slot name="invalidCode">Ufff! Der Token zur Festlegung eines neuen Passwortes ist ungültig oder bereits
            abgelaufen.
          </slot>
        </b-form-invalid-feedback>
        <b-form-invalid-feedback v-else>
          <slot name="invalidRequired">Dies ist ein Pflichtfeld. (default)</slot>
        </b-form-invalid-feedback>
      </b-form-group>
      <MessageModal></MessageModal>
      <Stepper
        @prev="back()"
        @next="next()"
      >
        <template slot="btnNext">
          <slot name="ctaNext"></slot>
        </template>
        <template slot="btnPrev">
          <slot name="ctaPrevious"></slot>
        </template>
      </Stepper>
    </b-form>
    <dyn-slot :slot-data="slotData">
      <slot name="txtAfter"></slot>
    </dyn-slot>
  </div>
</template>

<script>
import { BForm, BFormGroup, BFormInput, BFormInvalidFeedback } from 'bootstrap-vue'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { mapGetters, mapMutations } from 'vuex'
import isValid from '@/mixins/validators/isValid'
import validationFlow from '@/mixins/validators/validationFlow'
import SMSTokenValidator from '@/mixins/validators/SMSTokenValidator'
import moment from 'moment/src/moment'
import Stepper from '@/components/generic/Stepper.vue'
import MessageModal from '@/components/generic/MessageView/MessageList.vue'

export default {
  name: 'ForgotPasswordToken',
  data () {
    return {
      code: '',
      displayErrorMessage: false,
      now: new Date(),
      interval: null
    }
  },
  props: {
    tokenPlaceholder: {
      type: String,
      default: 'Dein SMS-Code'
    }
  },
  components: {
    MessageModal,
    Stepper,
    BFormGroup,
    BFormInput,
    BForm,
    BFormInvalidFeedback
  },
  mounted () {
    this.startTimer()
    this.otp()
  },
  methods: {
    otp () {
      if ('OTPCredential' in window) {
        const ac = new AbortController()
        // Invoke the WebOTP API
        navigator.credentials.get({
          otp: { transport: ['sms'] },
          signal: ac.signal
        }).then(otp => {
          console.log('SMS Code')
          console.log(otp)
          this.code = otp.code
        }).catch(err => {
          console.log('SMS Error')
          console.log(err)
        })
      }
    },
    next () {
      this.$v.code.$touch()
      this.vflowForceFeedback()
      if (this.$v.$invalid) {
        // ensure live feedback for validation errors
        this.vFlowGetFirstErrorElementName().then(function (result) {
          const data = {
            type: 'validation',
            message: 'required field missing',
            location: result + ' - unknown'
          }
          if (typeof window.trackingNS?.track?.tracking === 'function') {
            window.trackingNS.track.tracking('error', data)
          }
        })
        return
      }
      this.captureToken(this.code)
    },
    ...mapMutations('forgotPassword', [
      'captureToken', 'setView'
    ]),
    startTimer () {
      this.interval = setInterval(function () {
        this.now = new Date()
      }.bind(this), 1000)
    },
    back () {
      this.setView('input')
    }
  },
  mixins: [
    validationMixin,
    isValid,
    validationFlow,
    SMSTokenValidator
  ],
  validations () {
    return {
      code: {
        required,
        tokenValidation (v) {
          return this.valideSMSToken(v)
        }
      }
    }
  },
  computed: {
    ...mapGetters('forgotPassword', [
      'validityPeriod'
    ]),
    transformToDayFormat: function () {
      return moment(String(this.validityPeriod)).format('DD.MM.YYYY, HH:mm')
    },
    transformToCountdown: function () {
      return moment.utc(this.countDown).format('mm:ss')
    },
    countDown () {
      return moment(this.validityPeriod) - moment(this.now)
    },
    countdownCheck () {
      return this.countDown > 0
    },
    slotData () {
      return {
        code: this.code,
        countdownCheck: this.countdownCheck,
        transformToDayFormat: this.transformToDayFormat,
        transformToCountdown: this.transformToCountdown,
        displayErrorMessage: this.displayErrorMessage
      }
    }
  }
}
</script>
